export default "__VITE_ASSET__ByRh7P3$__"